export default "__VITE_ASSET__BnCC8yCw__ 960w, __VITE_ASSET__C1dnl2lP__ 1420w";